<template>
    <div class="ui segment center aligned core_waybill_partition">
        <div class="ui small horizontal statistic" v-if="core_waybill.partition">
            <div class="value">
                <!-- <span :data-tooltip="'字軌'" :data-position="'bottom left'">
                    {{ core_waybill.partition.prefix }}
                </span> -->
                <span>
                    <span style="font-size: 22px;">
                        <!-- 所使用的號碼區間： -->
                        {{ $t('ui.toolbox.core_waybill.use_partition') }}：
                    </span>
                    <span :data-tooltip="$t('ui.toolbox.core_waybill.partition_number_from')" :data-position="'bottom center'">
                        {{ core_waybill.partition.numbers_from }}
                    </span>
                    <span> ~ </span>
                    <span :data-tooltip="$t('ui.toolbox.core_waybill.partition_number_to')" :data-position="'bottom center'">
                        {{ core_waybill.partition.numbers_to }}
                    </span>
                </span>
            </div>
            <div class="label">
                {{ core_waybill.partition.name }}
                <!-- 共{{ core_waybill.partition.numbers_to - core_waybill.partition.numbers_from +1 }}筆 -->
            </div>
        </div>
        <div v-else>
            <h5>
                {{ $t('ui.general.no_data') }} {{ $t('models.partitions') }}
            </h5>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
    },
    data() {
        return {
            is_grid_table_style: false,
        }
    },
    created() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        integer_rjust(integer, width, padding) {
            return integer.toString().rjust(width, padding)
        },
    },
    components: {
    },
}
</script>

<style lang="scss" scoped>
    .segment.core_waybill_partition {
        margin-top: 0;
    }
    .horizontal.statistic .value {
        text-transform: none;
    }
</style>
